<template>
  <div class="container-fluid">
    <input v-if="galleryOptions !== null" v-file-uploader="galleryOptions" type="file" name="files" class="gallery_media" />
  </div>
</template>

<style lang="scss" scoped>
</style>

<script src="../../../../assets/libs/fileuploader-2.2/jquery.fileuploader.min.js" type="text/javascript"></script>

<script>

import VueFileUploader from "./../../../../directives/VueFileUploader.js";

export default {
  name: "TypedSurveyImages",
  components: {},
  directives: {
    VueFileUploader
  },
  props: ['item', 'assetUrl'],
  data() {
    return {
      galleryOptions: null
    };
  },
  mounted() {
    var files = [];

    if (this.item.imageUrls !== null) {
      files = this.item.imageUrls.map(imageUrl => (
      {
          name: 'item.jpg',
          size: 1,
          type: 'image/jpg',
          file: imageUrl,
          data: {
            url: imageUrl
          }
        }
      ));
    }

    const url = process.env.VUE_APP_API + '/survey/images/' + this.assetUrl;

    this.galleryOptions = {
      deletingImage: false,
      uploadUrl: url,
      deleteUrl: url,
      sortUrl: url,
      files: files
    };
  },
  beforeDestroy: function() {
  },
  methods: {}
};
</script>